import {USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/profileBasic'
import simpleSnackbarActions from '../../../common/actions/simpleSnackbar'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {profileBasic as text} from '../text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class profileBasic {

  static setName(name) {
    return {
      type: types.SET_NAME,
      payload: {
        value: name,
      },
    }
  }

  static setLastName(lastName) {
    return {
      type: types.SET_LAST_NAME,
      payload: {
        value: lastName,
      },
    }
  }

  static save() {
    return function(dispatch, getState) {

      const state = getState().ui.profile.profileBasic
      const name = state.getIn(['name', 'value'])
      const lastName = state.getIn(['lastName', 'value'])

      if (name === '' || lastName === '') {
        dispatch(profileBasic.saveFail(''))
        return
      }

      dispatch({type: types.SAVE})

      const data = new FormData()
      data.append('first_name', name)
      data.append('last_name', lastName)

      apiPrivate.put(USER_PROFILE + '/user/profile', data)
        .then(response => {
          dispatch(profileBasic.saveSuccess())
          dispatch(simpleSnackbarActions.showMessage(text.saveSuccess))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(profileBasic.saveFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(profileBasic.saveFail(message))
        })
    }
  }

  static saveSuccess() {
    return {
      type: types.SAVE_SUCCESS,
    }
  }

  static saveFail(error) {
    return {
      type: types.SAVE_FAIL,
      payload: {
        error,
      },
    }
  }

  static setPicture(picture) {
    return {
      type: types.SET_PICTURE,
      payload: {
        value: picture,
      },
    }
  }

  static setFile(file) {
    return {
      type: types.SET_FILE,
      payload: {
        file,
      },
    }
  }

  static savePicture() {
    return function(dispatch, getState) {

      const state = getState().ui.profile.profileBasic
      const picture = state.getIn(['picture', 'file'])

      if (picture === '') {
        dispatch(profileBasic.savePictureFail(''))
        return
      }

      dispatch({type: types.SAVE})

      const data = new FormData()
      data.append('profile_picture', picture)

      apiPrivate.post(USER_PROFILE + '/user/profile/picture', data)
        .then(response => {
          dispatch(profileBasic.savePictureSuccess())
          dispatch(simpleSnackbarActions.showMessage(text.pictureSavedSuccess))
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(profileBasic.savePictureFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(profileBasic.savePictureFail(message))
        })
    }
  }

  static savePictureSuccess() {
    return {
      type: types.SAVE_PICTURE_SUCCESS,
    }
  }

  static savePictureFail(error) {
    return {
      type: types.SAVE_PICTURE_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/profile/actions/profileBasic.js